module.exports = __webpack_public_path__ + "img/secondary_9x1_z16.2d6a7305.svg";